<dhp-filter-date-range-dialog
  class="hidden md:flex"
  [filterName]="filterName"
  (dateRangeOutput)="filterOutput.emit($event)"
/>
<dhp-filter-date-range-accordion
  class="md:hidden"
  [filterName]="filterName"
  (dateRangeOutput)="filterOutput.emit($event)"
/>
